import { FormikProps } from "formik"
import React, { useRef, MutableRefObject } from "react"
import { useTranslation } from "react-i18next"
import { ErrorType } from "../../../error/ErrorType"
import { success } from "../../validation/FormValidator"
import { error, ValidationResult } from "../../validation/ValidationError"
import { useNetgiroPaymentApi } from "../../../netgiro/NetgiroHooks"
import { paymentApiUrl } from "../../../Config"

export const useNetgiroValidation = (cartId: string) => {
  const { t } = useTranslation("checkout")
  const netgiroApi = useNetgiroPaymentApi()
  const formRef = useRef<HTMLFormElement | null>(null)
  const applicationIdRef = useRef<HTMLInputElement | null>(null)
  const signatureRef = useRef<HTMLInputElement | null>(null)
  const totalAmountRef = useRef<HTMLInputElement | null>(null)
  const referenceNumberRef = useRef<HTMLInputElement | null>(null)
  const paymentSuccessfulURLRef = useRef<HTMLInputElement | null>(null)

  const safelySetInputElementValue = (
    ref: MutableRefObject<HTMLInputElement | null>,
    value?: string | number
  ) => {
    if (ref.current !== null) ref.current.value = value ? `${value}` : ""
  }

  const save = (): ValidationResult => {
    if (!cartId) {
      return error(ErrorType.PaymentError, {
        title: t("paymentFailedTitle"),
        message: t("paymentFailedMessage")
      })
    }
    const host = window?.location?.origin || "https://66north.com"
    const successfulPaymentUrl = `${host}${paymentApiUrl(`netgiro/carts/${cartId}/success`)}`
    return netgiroApi
      .signRequest({ cartId })
      .then(({ applicationId, referenceNumber, signature, totalAmount }) => {
        safelySetInputElementValue(applicationIdRef, applicationId)
        safelySetInputElementValue(signatureRef, signature)
        safelySetInputElementValue(totalAmountRef, totalAmount)
        safelySetInputElementValue(referenceNumberRef, referenceNumber)
        safelySetInputElementValue(
          paymentSuccessfulURLRef,
          successfulPaymentUrl
        )
        //submit the form and wait to return the promise, this will avoid a race condition in Safari that is redirecting to the /processing page before submitting the form
        formRef.current?.submit()
        return new Promise(resolve => setTimeout(resolve, 1000))
      })
      .then(() => success())
  }

  return {
    formRef,
    applicationIdRef,
    signatureRef,
    totalAmountRef,
    referenceNumberRef,
    paymentSuccessfulURLRef,
    save
  }
}
